import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  tabsRoot: {
    paddingLeft: '1.5rem',
    backgroundColor: theme.colors.eyConfidentGrey,
  },
  tabsIndicator: {
    backgroundColor: theme.colors.eyYellow,
    borderBottom: `1px solid ${theme.colors.eyYellow}`,
  },
  tabRoot: {
    color: theme.colors.eyGrey6,
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    padding: '0 1.25rem',
    backgroundColor: theme.colors.eyGrey0,
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: theme.colors.eyGrey4,
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.colors.eyInteractiveOverlays,
    },
    '&:focus': {
      color: theme.colors.white,
    },
  },
  tabSelected: {},
  label: {
    fontSize: '14px',
  },
  typography: {
    padding: theme.spacing.unit * 3,
  },
  allCases: {
    backgroundColor: '#1777CF',
  },
  openCases: {
    backgroundColor: '#2DB757',
  },
  closedCases: {
    backgroundColor: '#FF4136',
  },
});

class TabBase extends React.Component {
  config = {
    indicatorColors: [],
  };
  state = {
    value: this.props.defaultValue || 0,
    tabClick: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    /* This code is needed so that the tabs can accept a value
     * from an outside routing, not just by clicking the tab */
    return {
      tabClick: false,
      value: nextProps.tabIdx !== undefined && !prevState.tabClick ? nextProps.tabIdx : prevState.value,
    };
  }

  handleChange = (event, value) => {
    let { handleChangeStatus } = this.props;

    this.setState({ value, tabClick: true }, () => {
      handleChangeStatus(this.state.value);
    });
  };

  generateTabs = (props, otherProps) => {
    let { classes, labels, openCaseCount, closedCaseCount, allCaseCount, styleType } = props;
    let casesCount = 0;
    // clear indicatorColors and push all new colors for tabIndicators
    this.config.indicatorColors.length = 0;
    return labels.map((label, index) => {
      let colorType = 'primary';
      let labelType = label.toLowerCase();
      if (allCaseCount && labelType === 'all cases') {
        colorType = 'primary';
        casesCount = allCaseCount;
        this.config.indicatorColors.push(classes.allCasesIndicator);
      } else if (openCaseCount && labelType === 'open cases') {
        colorType = 'secondary';
        casesCount = openCaseCount;
        this.config.indicatorColors.push(classes.openCasesIndicator);
      } else if (closedCaseCount && labelType === 'closed cases') {
        colorType = 'error';
        casesCount = closedCaseCount;
        this.config.indicatorColors.push(classes.closedCasesIndicator);
      } else {
        this.config.indicatorColors.push(classes.tabsIndicator);
        casesCount = 0;
      }

      return styleType === 'primary' ? (
        <Tab
          key={label + index}
          value={index}
          disableRipple
          classes={{ root: classes.tabRoot, selected: classes.tabSelected, label: classes.label }}
          label={label}
          {...otherProps}
        />
      ) : (
        <Tab
          key={label + index}
          disableRipple
          classes={{ root: classes.tabRoot, selected: classes.tabSelected, label: classes.label }}
          label={
            <Badge
              classes={{
                root: classes.badge,
                colorPrimary: classes.allCases,
                colorSecondary: classes.openCases,
                colorError: classes.closedCases,
              }}
              badgeContent={casesCount}
              color={colorType}
              children={label}
            />
          }
          {...otherProps}
        />
      );
    });
  };

  render() {
    const {
      classes,
      styleType,
      openCaseCount,
      closedCaseCount,
      allCaseCount,
      labels,
      children,
      handleChangeStatus,
      defaultValue,
      ...otherProps
    } = this.props;
    const { value } = this.state;

    let props = {
      styleType,
      openCaseCount,
      closedCaseCount,
      allCaseCount,
      classes,
      labels,
    };

    const val = this.props.defaultValue ? this.props.defaultValue : value;
    const tabs = this.generateTabs(props, otherProps);

    return (
      <div className={classes.root}>
        <Tabs
          value={val}
          onChange={this.handleChange}
          classes={{ root: classes.tabsRoot, indicator: this.config.indicatorColors[val] }}
          {...otherProps}>
          {tabs}
        </Tabs>
        {children}
      </div>
    );
  }
}

TabBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

export { TabBase };
export default styled(TabBase)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Tab/TabBase.js